import * as t from 'io-ts'

export const AssetManifestCodec = t.type({
    files: t.record(t.string, t.string),
    entrypoints: t.array(t.string),
})

export type AssetManifest = t.TypeOf<typeof AssetManifestCodec>
